export default "__VITE_ASSET__eU9sckEp__"